import React from 'react';

// Types
import { FormTypeType, ReviewFormTemplateType } from 'Shared/types/ReviewFormTemplate.type';

// Hooks
import { useReviewFormTemplate } from 'Shared/utils/hooks/use-review-form-template';

// Components
import TemplateQuestions from './TemplateQuestions';
import { WpButton } from 'Wpds/components/button';
import { WpIcon } from 'Wpds/components/icon';
import { WpText } from 'Wpds/components/text';
import WpAlert from 'Wpds/components/alert/WpAlert';

// Styles
import './EditFormTemplateItem.scss';

type Props = {
  handleChangeView: () => void;
  reviewFormType: FormTypeType;
  reviewFormTemplate: ReviewFormTemplateType;
};

const EditFormTemplateItem = ({ handleChangeView, reviewFormType, reviewFormTemplate }: Props) => {
  const { title, description } = useReviewFormTemplate({ reviewFormTemplate });

  const showAlert = reviewFormType === FormTypeType.manager_peer_review;

  const handleBackClick = () => {
    handleChangeView();
  };
  if (!reviewFormType) return null;

  const baseClassName = 'EditFormTemplateItem';
  return (
    <div className={baseClassName}>
      <WpButton variant="link" onClick={handleBackClick} color="gray">
        <WpIcon name="arrow-left" />
        Back to template
      </WpButton>
      <div className={`${baseClassName}__content`}>
        <WpText variant="bodyXl" bold noMargin>
          {title}
        </WpText>
        <WpText color="gray-600">{description}</WpText>
        {showAlert && (
          <div className={`${baseClassName}__content__alert`}>
            <WpAlert type="warning" icon={<WpIcon name="eye"></WpIcon>}>
              Direct reports will be able to see their manager’s reviews once shared.
            </WpAlert>
          </div>
        )}
        <TemplateQuestions reviewFormType={reviewFormType} />
      </div>
    </div>
  );
};

export default EditFormTemplateItem;
